export enum NavRequest {
  CONTINUE = 'continue',
  PREVIOUS = 'previous',
  CHOICE = 'choice',
  JUMP = 'jump',
  EXIT = 'exit',
  EXIT_ALL = 'exitAll',
  ABANDON = 'abandon',
  ABANDON_ALL = 'abandonAll',
  NONE = '_none_',
}

export enum NavRequestValid {
  TRUE = 'true',
  FALSE = 'false',
  UNKNOWN = 'unknown',
}

export default interface ADLInterface {
  nav: {
    request: NavRequest, // Allowed values: "continue", "previous", "choice", "jump", "exit", "exitAll", "abandon", "abandonAll", "_none_"
    request_valid: {
      continue: NavRequestValid
      previous: NavRequestValid
      choice: {
        _isTargetValid: Function
      },
      jump: {
        _isTargetValid: Function
      }
    }
  }
}
